import { useEffect } from "react";
import { useHome } from "../../../../hooks/useHome"
import { pathPDF } from "../../../../routes/endpoints";

export const TextCarousel = () => {
  const { carruselText, getCarruselTextos } = useHome();

  useEffect(() => {
    getCarruselTextos()
  }, [])

  return (
    <div className="row" role="article" aria-label="sitio de interés">
      <div className="col-12 slide-novedades">
        <div className="container-fluid">
          <div id="slideNovedades" className="carousel slide">
            <div className="carousel-inner">
              {carruselText.map(({ id, titulo, archivo, url }, i) => (
                  <div key={id} className={`carousel-item ${i === 0 ? "active" : ""}`}>
                    {url || archivo ?
                      <a href={url ? url : `${pathPDF}${archivo}`} className="texto-novedades" target="_blank" role="link" aria-label={`${titulo}`}>
                        {titulo}
                      </a>
                      :
                      <p className="texto-novedades">
                        {titulo}
                      </p>
                    }
                  </div>
                ))
              }
            </div>
            <button className="carousel-control-prev prev-responsivo" type="button" data-bs-target="#slideNovedades"
              data-bs-slide="prev">
              <span className="carousel-control-prev-icon tamano-icon-nav" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next next-responsivo" type="button" data-bs-target="#slideNovedades"
              data-bs-slide="next">
              <span className="carousel-control-next-icon tamano-icon-nav" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
